export enum ClosureInventoryStateEnum {
  REINIT = 'REINIT',
  NOT_REINIT = 'NOT_REINIT',
  NO_CHOICE = 'NO_CHOICE',
}
